import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BRAND_LOGO_URL, EMBLEM_URL } from '../utils/brandAssets';
import './Contact.css';

const Contact = () => {
  const [askLogoError, setAskLogoError] = useState(false);
  const [emblemError, setEmblemError] = useState(false);

  const handleAskLogoError = () => {
    setAskLogoError(true);
  };

  const handleEmblemError = () => {
    setEmblemError(true);
  };

  return (
    <div className="contact-page">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} md={8} lg={6}>
            <div className="contact-container">
              {/* ASK Logo */}
              <div className="contact-logo-section">
                {!askLogoError ? (
                  <img 
                    src={BRAND_LOGO_URL} 
                    alt="ASK Logo" 
                    className="contact-ask-logo"
                    onError={handleAskLogoError}
                  />
                ) : (
                  <div className="contact-logo-fallback">
                    <h3 className="contact-logo-text">ASK</h3>
                    <p className="contact-logo-subtitle">Kosovo Agency of Statistics</p>
                  </div>
                )}
              </div>

              {/* Contact Information */}
              <div className="contact-info">
                <div className="contact-item">
                  <h5 className="contact-label">Address</h5>
                  <p className="contact-text">
                    Rr. Zenel Salihu 10 000<br />
                    Prishtinë, Republika e Kosovës
                  </p>
                </div>

                <div className="contact-item">
                  <h5 className="contact-label">Email</h5>
                  <p className="contact-text">
                    <a href="mailto:infoask@rks-gov.net" className="contact-link">
                      infoask@rks-gov.net
                    </a>
                  </p>
                </div>

                <div className="contact-item">
                  <h5 className="contact-label">Phone</h5>
                  <p className="contact-text">
                    <a href="tel:+38338200311129" className="contact-link">
                      (+383) 038 200 31 129
                    </a>
                  </p>
                </div>
              </div>

              {/* Kosovo Emblem */}
              <div className="contact-emblem-section">
                {!emblemError ? (
                  <img 
                    src={EMBLEM_URL} 
                    alt="Kosovo Emblem" 
                    className="contact-kosovo-emblem"
                    onError={handleEmblemError}
                  />
                ) : (
                  <div className="contact-emblem-fallback">
                    <div className="contact-emblem-text">🇽🇰</div>
                    <p className="contact-emblem-subtitle">Republika e Kosovës</p>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
